import { Box, Stack } from '@ardoq/layout';
import { Label } from '@ardoq/forms';
import { SurveyHelpText } from './SurveyHelpText';
import { PersistedTextQuestion } from '@ardoq/api-types';

export type SurveyTextSectionProps = {
  question: PersistedTextQuestion;
};

export const SurveyTextSection = ({ question }: SurveyTextSectionProps) => {
  return (
    <Box
      padding="large"
      marginY="medium"
      backgroundColor="surfaceDefaultSubtle"
      borderRadius="r4"
    >
      <Stack gap="small">
        <Label>{question.label}</Label>
        {question.description ? (
          <SurveyHelpText text={question.description} />
        ) : null}
      </Stack>
    </Box>
  );
};
